<template>
	<div>
		<div class="max-height-200">
			<b-container>
				<b-row class="mb-3">
					<b-col sm="3" v-if="companyType !== 'SHOP' ">
						<b-form-select v-model="filter.category" :options="allCategory" value-field="id" text-field="name" size="sm">
							<template slot="first">
								<option value="all">-- Все Категории --</option>
							</template>
						</b-form-select>
					</b-col>
					<b-col sm="3">
						<b-form-select v-model="subcategory.value" :disabled="subcategory.isDisabled" size="sm">
							<option v-for="(selectOption, indexOpt) in subcategory.items" :key="indexOpt" :value="selectOption.id">
								{{ selectOption.name }}
							</option>
							<template slot="first">
								<option :value="null">-- {{ companyType === 'SHOP' ? 'Все Группы' : 'Все Подкатегории'}} --</option>
							</template>
						</b-form-select>
					</b-col>
					<b-col sm="3">
						<b-form-select v-model="subsubcategory.value" :disabled="!subcategory.value" size="sm">
							<option v-for="(selectOption, indexOpt) in subsubcategory.items" :key="indexOpt" :value="selectOption.id">
								{{ selectOption.name }}
							</option>
							<template slot="first">
								<option :value="null">-- {{ companyType === 'SHOP' ? 'Все Категории' : 'Все Подкатегории'}} --</option>
							</template>
						</b-form-select>
					</b-col>
					<b-col sm="3">
						<b-form-select v-model="sub3category.value" :disabled="!subsubcategory.value" size="sm">
							<option v-for="(selectOption, indexOpt) in sub3category.items" :key="indexOpt" :value="selectOption.id">
								{{ selectOption.name }}
							</option>
							<template slot="first">
								<option :value="null">-- Все Под категории --</option>
							</template>
						</b-form-select>
					</b-col>
					<b-col sm="3">
						<b-form-input id="name" size="sm" v-model="artikul" name="name" :placeholder="$t('goods.artikul')" v-on:keyup.enter="accept"></b-form-input>
					</b-col>
				</b-row>
				<b-row class="mb-4">
<!--					<b-col sm="3">-->
<!--						<b-form-select v-model="dropdowns.brands.value" size="sm">-->
<!--							<option v-for="(selectOption, indexOpt) in dropdowns.brands.items" :key="indexOpt" :value="selectOption.id">-->
<!--								{{ selectOption.name }}-->
<!--							</option>-->
<!--							<template slot="first">-->
<!--								<option :value="null">&#45;&#45; BRANDS &#45;&#45;</option>-->
<!--							</template>-->
<!--						</b-form-select>-->
<!--					</b-col>-->
<!--					<b-col cols="3">-->
<!--						<b-form-select v-model="gender" size="sm">-->
<!--							<option v-for="(selectOption, indexOpt) in genders" :key="indexOpt" :value="selectOption.id">-->
<!--								{{ selectOption.name }}-->
<!--							</option>-->
<!--							<template slot="first">-->
<!--								<option :value="null">&#45;&#45; Пол &#45;&#45;</option>-->
<!--							</template>-->
<!--						</b-form-select>-->
<!--					</b-col>-->
					<b-col sm="3">
						<b-form-input id="barcode" size="sm" v-model="name" name="name" :placeholder="$t('goods.name')" v-on:keyup.enter="accept"/>
					</b-col>
					<b-col sm="3">
						<b-form-input id="barcode" size="sm" v-model="barcode" name="name" :placeholder="$t('goods.special-barcode')" v-on:keyup.enter="accept"/>
					</b-col>
					<b-col sm="3">
						<b-form-input id="barcode" size="sm" v-model="multiBarcode" name="name" :placeholder="$t('goods.barcode')" v-on:keyup.enter="accept"/>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-button @click="accept" class="pull-right" variant="primary">{{ $t('apply') }}</b-button>
					</b-col>
				</b-row>
				<hr>
				<div class="table-responsive table-wrapper">
					<b-table striped hover :items="items" :fields="refField" bordered="bordered" show-empty class="generalTableClass">
						<template slot="empty" slot-scope="scope">
							<h6>{{ $t('empty') }}</h6>
						</template>
						<template slot="check" slot-scope="data">
							{{ paginate(data.index, searchForm.page, searchForm.limit) }}
						</template>
						<template slot="multiBarcode" slot-scope="data">
							<span v-for="barcode in data.item.multiBarcodes">{{ barcode.barcode }}<br></span>
						</template>
					</b-table>
				</div>
				<nav>
					<b-pagination :total-rows="total" :per-page="searchForm.limit" v-model="searchForm.page"
								  :prev-text="$t('pagination.prev')"
								  :next-text="$t('pagination.next')"
								  hide-goto-end-buttons/>
				</nav>
			</b-container>
		</div>
		<div class="mt-1">
			<hr>
			<b-button class="pull-right" variant="primary" @click="save" size="sm">{{ $t('save') }}</b-button>
		</div>
	</div>
</template>

<script>

	import ReferencesService from "../../../../services/references.sevice";
	import {mapActions, mapGetters, mapState} from "vuex";
	import {TokenService} from "../../../../services/storage.service";
	import GoodsService from "../../../../services/goods.service";

	export default {
		name: 'AddChildren',

		props: {
			defaults: {
				type: Array
			},
			newMessForSpisok: {
				type: String,
				default: ''
			},
			mode: {
				type: String,
				default: 'create'
			},
		},

		data() {
			return {
				artikul: '',
				loader: true,
				name: '',
				barcode: '',
				multiBarcode: '',
				total: 0,
				selected: [],
				items: [],
				isLoading: false,
				dropdowns: {
					brands: {
						items: [],
						value: null
					},
				},
				filter: {
					category: 'all'
				},
				subcategory: {
					items: [],
					value: null,
					isDisabled: true,
				},
				subsubcategory: {
					items: [],
					value: null,
					isDisabled: true,

				},
				sub3category: {
					items: [],
					value: null,
					isDisabled: true,
				},
				genders: [],
				gender: null,
				companyType: '',
				allCategory: [],
				search: {},
				searchForm: {
					page: 1,
					limit: 20,
					attributes: {}
				},
				refField: [
					{key: 'check', label: '№'},
					{
						key: 'barcode',
						label: this.$t('goods.special-barcode'),
						'class': 'td-20',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'name',
						label: this.$t('goods.name'),
						'class': 'td-40',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'multiBarcode',
						label: this.$t('goods.barcode'),
						'class': 'td-40',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'artikul',
						label: this.$t('goods.artikul'),
						'class': 'td-20',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'subCategoryName',
						label: this.$t('goods.create.select-group'),
						'class': 'td-20',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'sub2CategoryName',
						label: this.$t('goods.category'),
						'class': 'td-20',
						sortable: true,
						visible: true,
						changebale: true
					}
				]
			}
		},

		methods: {
			...mapActions('references', [
				'getReferenceChildren',
			]),
			...mapActions('goods', [
				'fetchSearchGoodsForPos'
			]),
            paginate(index, page_size, page_number) {
                --page_size;
                return (page_number * page_size) + index + 1;
            },
			setItem($event, item) {
				if ($event) {
					this.selected.push({
						wrappedId: item.id,
						color: item.color,
						model: item.model,
						sku: item.sku,
						barcode: item.barcode,
						size: item.size,
						name: item.name,
						amount: 0,
						newSpisok: this.newMessForSpisok
					});
				} else {
					this.selected.map((selected, i) => {
						if (selected.wrappedId === item.id) {
							this.selected.splice(i, 1);
						}
					})
				}
			},
			save() {
				this.$emit('success', this.selected, this.search);
			},
			isChecked(id) {
				return this.getDef.find(item => this.included(item, id));
			},
			included(attr, value) {
				return attr.wrappedId === value;
			},
			clear() {
				this.search.attributes[0].value = '';
			},
			loadBrands() {
				ReferencesService.getReferenceChildren(`item_brand`).then(response => {
					this.dropdowns.brands.items = response.data;
				})
			},

			checkChecked(id, all = null) {
				if (all === null) {
					let checked = true
					this.defaults.forEach(item => {
						if (item.wrappedId === id)
							checked = true
					})

					return checked
				} else {
					return true
				}

			},
			async loadCategory() {
				await ReferencesService.getReferenceChildren(`WAREHOUSE_CATEGORY`).then(response => {
					this.allCategory = response.data;
				})
			},
			loadSubCategory(id) {
				ReferencesService.getSubReferenceChildren(id).then(response => {
					this.subcategory.items = response.data;
				})
			},
			loadSubSubCategory(id) {
				ReferencesService.getSubReferenceChildren(id).then(response => {
					this.subsubcategory.items = response.data;
				})
			},
			loadSub3Category(id) {
				ReferencesService.getSubReferenceChildren(id).then(response => {
					this.sub3category.items = response.data;
				})
			},
			setCompanyType() {
				this.companyType = TokenService.getDepartmentType()
				if (this.companyType === 'SHOP') {

					this.allCategory.filter(el => {
						if (el.code === 'MAGAZIN') {
							this.category = el.id
						}
					})

					this.loadSubCategory(this.category)
					this.subcategory.isDisabled = false;
				}

			},
			checkAlreadyInSearch(field, newValue) {

				delete this.search[field]
				this.search[field] = newValue

			},
			removeSubCategoryId(field) {
				delete this.search[field]
			},
			loadGenders() {
				ReferencesService.getReferenceChildren('GENDER').then(response => {
					this.genders = response.data;
				})
			},
			async getItemsForPos() {
				this.loader = true;
				if (this.companyType === 'SHOP') {
					this.allCategory.filter(el => {
						if (el.code === 'MAGAZIN') {
							this.search.categoryId = el.id
						}
					})
				}
				this.search.artikul = this.artikul;
				this.search.genderId = this.gender;
				this.search.name = this.name;
				this.search.barcode = this.barcode;
				this.search.multiBarcode = this.multiBarcode;
				this.searchForm.attributes = this.search;

				await GoodsService.getFiltereGoodsForPos(this.searchForm).then(response => {
					this.items = response.data.items;
					this.total = response.data.total;
					this.selected = []
					this.items.forEach(item => {
						this.checkChecked(item.id, true);

						this.selected.push({
							wrappedId: item.id,
							color: item.color,
							model: item.model,
							sku: item.sku,
							barcode: item.barcode,
							size: item.size,
							name: item.name,
							amount: 0,
							artikul: item.artikul,
						});
					})
					this.$emit('setItems', this.selected)

					this.loader = false;
				}).catch(() => {
					this.loader = false;
				});


			},

			async accept() {
				if (this.companyType === 'SHOP') {
					//if(this.subcategory.value !== null)
					await this.getItemsForPos();
				} else {
					await this.getItemsForPos();
				}

			}
		},
		computed: {
			...mapGetters('references', [
				'getRefChildren'
			]),
			notWrapped: function () {
				return this.items.filter(item => {
					if (item.id !== this.parentId) {
						item['count'] = 0;
						(this.isChecked(item.id)) ? item['checked'] = true : item['checked'] = false;

						return item
					}
				})
			},
			getDef() {
				return this.defaults || [];
			},


		},
		mounted() {
			setTimeout(() => {
				this.selected = this.getDef;
			}, 200);
		},
		async created() {
			await this.loadCategory();
			this.setCompanyType();
			this.loadBrands();
			this.loadGenders();
		},
		watch: {
			'filter.category': {
				handler(newValue) {
					if (newValue === 'all') {
						this.subcategory.value = null
						this.subsubcategory.value = null
						this.removeSubCategoryId('categoryId')
					} else {
						this.checkAlreadyInSearch('categoryId', newValue)
						this.subcategory.value = null
						this.subcategory.isDisabled = false
						this.subsubcategory.isDisabled = true
						this.subsubcategory.value = null
						this.sub3category.value = null
						this.sub3category.isDisabled = true
						this.loadSubCategory(newValue)
					}

					this.removeSubCategoryId('sub')
					this.removeSubCategoryId('sub2')
					this.removeSubCategoryId('sub3')

				}
			},
			'subcategory.value': {
				handler(newValue) {
					if (newValue === null) {
						this.subsubcategory.value = null
						this.removeSubCategoryId('sub')
					} else {
						this.checkAlreadyInSearch('sub', newValue)
						this.subsubcategory.isDisabled = false
						this.loadSubSubCategory(newValue)
					}
					this.subsubcategory.value = null
					this.sub3category.value = null
					this.sub3category.isDisabled = true
					this.removeSubCategoryId('sub2')
					this.removeSubCategoryId('sub3')


				}
			},
			'subsubcategory.value': {
				handler(newValue) {
					if (newValue === null) {
						this.sub3category.value = null
						this.removeSubCategoryId('sub2')
					} else {
						this.checkAlreadyInSearch('sub2', newValue)
						this.sub3category.isDisabled = false
						this.loadSub3Category(newValue)
					}
					this.sub3category.value = null
					this.removeSubCategoryId('sub3')


				}
			},
			'sub3category.value': {
				handler(newValue) {
					if (newValue === null) {
						this.removeSubCategoryId('sub3')
					} else {
						this.checkAlreadyInSearch('sub3', newValue)
					}


				}
			},
			'dropdowns.brands.value': {
				handler(newValue) {
					if (newValue === null) {
						this.removeSubCategoryId('brandId')
					} else {
						this.checkAlreadyInSearch('brandId', newValue)
					}


				}
			},

			'searchForm.page': {
				handler() {
					this.getItemsForPos();
					this.search.attributes = []
				}
			},

		}
	}
</script>

<style scoped>

	.max-height-200 {
		max-height: 60rem;
		overflow: auto;
	}

</style>
